import { dev } from '$app/environment';
import { trackGA } from './ga';
import { trackEvent } from '../segment/client';
import { toSnakeCase } from './string';
import { geolocation } from '$lib/state/geolocation.svelte';

export async function event<Data extends Record<string, unknown>>(
	name: string,
	data: Data = {} as Data
): Promise<void> {
	const eventData = {
		...data,
		geolocation: geolocation.data
	};

	await trackEvent(name, eventData);
	trackGA(toSnakeCase(name), eventData);

	if (dev) {
		console.groupCollapsed(`[Segment + GA] ${name} (${toSnakeCase(name)})`);
		console.table(eventData);
		console.groupEnd();
	}
}
